import gql from "graphql-tag";
export const saveRecordMutation = gql`
  mutation SaveRecord(
    $authToken: String
    $appId: String!
    $id: String
    $wer2: String
    $was2: String
    $notiz: String
    $bild: InputFieldFile
    $standort: InputFieldGeo
    $bewertung: [InputFieldLookup]
    $status: [InputFieldLookup]
    $aktion: String
    $durch_wen2: [InputFieldLookup]
  ) {
    saveRecord(
      authToken: $authToken
      id: $appId
      input: {
        id: $id
        fields: [
          { identifier: "wer2", value: $wer2 }
          { identifier: "was2", value: $was2 }
          { identifier: "was2", value: $was2 }
          { identifier: "notiz", value: $notiz }
          { identifier: "aktion", value: $aktion }
        ]
        fileFields: [{ identifier: "bild", value: $bild }]
        geoFields: [{ identifier: "standort", value: $standort }]
        lookupFields: [{ identifier: "bewertung", items: $bewertung }, { identifier: "status", items: $status }, { identifier: "durch_wen2", items: $durch_wen2 }]
      }
    ) {
      record {
        id
        wer2: value(identifier: "wer2") {
          ... on ValueTypeString {
            value
          }
        }
        was2: value(identifier: "was2") {
          ... on ValueTypeString {
            value
          }
        }
        notiz: value(identifier: "notiz") {
          ... on ValueTypeString {
            value
          }
        }
        bild: value(identifier: "bild") {
          ... on ValueTypeFile {
            value {
              id
              url
              filename
              mimetype
              width
              height
              createdat
            }
          }
        }
        standort: value(identifier: "standort") {
          ... on ValueTypeGeo {
            value {
              lat
              lng
              info
            }
          }
        }
        bewertung: value(identifier: "bewertung") {
          ... on ValueTypeLookUpItem {
            value {
              key
              label
            }
          }
        }
        status: value(identifier: "status") {
          ... on ValueTypeLookUpItem {
            value {
              key
              label
            }
          }
        }
        aktion: value(identifier: "aktion") {
          ... on ValueTypeString {
            value
          }
        }
        durch_wen2: value(identifier: "durch_wen2") {
          ... on ValueTypeLookUpItem {
            value {
              key
              label
            }
          }
        }
      }
    }
  }
`;
